import { ChartZoom } from "@/_core/refactor/ChartZoom";
import { ChartAxis } from "@/_core/refactor/ChartAxis";
import { ChartFigures } from "@/_core/refactor/ChartFigures";
import { ChartHover } from "@/_core/refactor/ChartHover";
import {
  backgroundGrad1,
  backgroundGrad2
} from "@/_core/_helpers/_parametric_tools";
import { select } from "d3";
export class Chart {
  constructor(name) {
    this.name = name;
    this.svg = null;
    this.svgAux = null;
    this.d3 = null;
    // Effects
    this.hoverElements = [];
    this.hoverElementDots = [];
    this.hereditaryHovers = [];
    this.zoomElements = [];
  }

  // AXIS
  setSVG({
    top = { perc: 0, px: 0 },
    right = { perc: 0, px: 0 },
    bottom = { perc: 0, px: 0 },
    left = { perc: 0, px: 0 },
    colorTheme = true,
    logo = null,
    logoPos = "up",
    isSmall = false
  }) {
    let parentElement = `${this.name}-div`;
    let childElement = `svg-${this.name}`;
    // set the dimensions and margins of the graph
    let chartDiv = document.getElementById(parentElement);
    // Extract the width and height that was computed by CSS.
    if (!chartDiv) return { height: 0, width: 0 };
    let width;
    if ("clientWidth" in chartDiv) width = chartDiv.clientWidth;
    else return { height: 0, width: 0 };
    let height = chartDiv.clientHeight;
    // Margins
    let margin = {
      top: Math.min(height * top.perc, top.px),
      right: Math.min(width * right.perc, right.px),
      bottom: Math.min(height * bottom.perc, bottom.px),
      left: Math.min(width * left.perc, left.px)
    };
    width = width - margin.left - margin.right;
    height = height - margin.top - margin.bottom;
    // Removing previous svg
    select("#" + childElement)
      .select("svg > *")
      .remove();
    // Creating SVG
    const svg = select("#" + childElement)
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom)
      .style("fill", "rgba(0, 0, 0, 0)")
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
    svg.parentElement = parentElement;
    svg.margin = margin;
    svg.width = width;
    svg.height = height;

    if (!colorTheme) {
      const grad = svg
        .append("defs")
        .append("linearGradient")
        .attr("id", "grad")
        .attr("x1", "100%")
        .attr("x2", "100%")
        .attr("y1", "0%")
        .attr("y2", "100%");

      const colors = [backgroundGrad1(colorTheme), backgroundGrad2(colorTheme)];
      grad
        .selectAll("stop")
        .data(colors)
        .enter()
        .append("stop")
        .style("stop-color", function(d) {
          return d;
        })
        .attr("offset", function(d, i) {
          return 100 * (i / (colors.length - 1)) + "%";
        });

      svg
        .append("rect")
        .attr("x", 0)
        .attr("y", 0)
        .attr("width", width)
        .attr("height", height)
        .attr("fill-opacity", 1)
        .style("fill", "url(#grad)");
    }

    // Logo
    if (logo) {
      let logoSize = isSmall ? 30 : 50;
      let offst = isSmall ? 10 : 20;
      let yPos = logoPos === "up" ? offst : svg.height - logoSize - offst;
      let xPos = logoSize + offst;
      svg
        .append("image")
        .attr("xlink:href", logo)
        .attr("x", svg.width - xPos + "px")
        .attr("y", yPos)
        .attr("width", logoSize + "px")
        .attr("height", logoSize + "px")
        .style("opacity", 0.3);
    }

    this.svg = svg;
  }
}

Object.assign(Chart.prototype, ChartAxis);
Object.assign(Chart.prototype, ChartZoom);
Object.assign(Chart.prototype, ChartFigures);
Object.assign(Chart.prototype, ChartHover);
